import { Spot } from '@doltech/ui/lib/figma/QuestionWithSpots/types';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { DoTestDragOutInstance } from '../../../student-do-test/model/Question/do-test-drag-out.store';
import { SharedDragInOut } from './DragInAnswerSubject';

interface DragInProps extends React.HTMLAttributes<HTMLDivElement> {
  data: DoTestDragOutInstance;
  isPdfContent: boolean;
}

export const DragOutAnswerSubject = observer((props: DragInProps) => {
  const { data } = props;
  const { questions, spots, no } = data;

  return (
    <SharedDragInOut
      {...props}
      className="drag-out-answer-subject"
      renderQuestionInsideImage={({ getSpotCoordinates }) => {
        return spots.map((spot: Spot, idx: number) => {
          const coordinates = getSpotCoordinates(spot);
          const style = {
            top: coordinates.top,
            left: coordinates.left,
          };
          return (
            <div key={spot.id} style={style} className="spot-item-container">
              <div className="spot-border">
                <div className="spot-item light">{spot.text}</div>
              </div>
            </div>
          );
        });
      }}
      renderQuestionList={() => {
        return (
          <div className="question-list">
            {questions.map((question, idx) => {
              const order = no + idx;
              return (
                <div key={idx} className="spot-item-container">
                  <div className="text">{question}</div>
                  <div className="spot-item">{order}</div>
                  <div className="input" />
                </div>
              );
            })}
          </div>
        );
      }}
    />
  );
});
